import type { WritableComputedRef, Ref } from 'vue';
import type { ProductAttributes } from '~/types';

interface ProductFavourites {
    isFavourite: WritableComputedRef<boolean>;
    favourites: Readonly<Ref<number[]>>;
}

export default function useProductFavourites(productId?: ProductAttributes['id']): ProductFavourites {
    const favourites = useLocalStorage<ProductAttributes['id'][]>('favourites', []);
    const isFavourite = computed({
        get: () => productId ? favourites.value.includes(productId) : false,
        set: (value: boolean) => {
            if (!productId) {
                return;
            }

            if (value) {
                useTrackEvent('favourited', {
                    productName: productStore.products.find(({ id }) => id === productId)!.name,
                    productId
                });

                favourites.value = [...favourites.value, productId];
            } else {
                favourites.value = favourites.value.filter(id => id !== productId);
            }
        }
    });
    const productStore = useProductStore();

    return {
        isFavourite,
        favourites
    };
}
